import { createContext } from '../../../@rc-component/context/es/context.js';
import createImmutable from '../../../@rc-component/context/es/Immutable.js';
var _createImmutable = createImmutable(),
  makeImmutable = _createImmutable.makeImmutable,
  responseImmutable = _createImmutable.responseImmutable,
  useImmutableMark = _createImmutable.useImmutableMark;
var TableContext = createContext();
export { TableContext as default, makeImmutable, responseImmutable, useImmutableMark };
//# sourceMappingURL=TableContext.js.map
